import secureLocalStorage from "react-secure-storage";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
import React from "react";
export default class ThreatAndOpportunities extends GridCell {

  constructor(props) {
    super(props);
    this.state = { oppertunityValue: "k-grid-content-sticky" };
   }
   componentDidMount(){
    // this.reportWindowSize();
   }
   reportWindowSize = () => {
    if(window.innerWidth > 768){
      this.setState({oppertunityValue:"k-grid-content-sticky"})
    }
    else{
      this.setState({oppertunityValue:""})
    }
   }

  handleChange(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let updateData = {
        ...this.props.dataItem,
        isOpportunityText: e.target.value.text,
        isOpportunityValue: e.target.value.value,
      };
      this.props.updateDropdownValue(updateData);
    }
  }

  handleEditCell = () => {
    this.props.onEditCell(this.props.dataItem, this.props.field);
  };
  render() {

    //  window.addEventListener('resize', this.reportWindowSize);
    //  window.addEventListener('load', this.reportWindowSize);
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId=dataItem.userId;

    const value = this.props.dataItem[this.props.field];
    const selectedValue = value
      ? this.props &&
        this.props.dropDownData.find((item) => item.text === value)
      : "";
    if (
      (this.props.field && this.props.field === this.props.dataItem.inEdit) ||
      this.props.dataItem.inEdit === true
    ) {
      return (
        <td className={this.state.oppertunityValue} 
        // style={{ left:'447px', right: "0px" }}
        >
          <DropDownList
            style={{ width: "100px" }}
            onChange={this.handleChange.bind(this)}
            value={selectedValue ? selectedValue : value}
            data={this.props ? this.props.dropDownData : []}
            valueField="value"
            textField="text"
          />
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if(loginUserId===ownerId){
        return(
        <td
          onClick={this.handleEditCell}
        //   className={this.state.oppertunityValue}
          // style={{ left: "447px", right: "0px" }}
        >
          {" "}
          {value === null || value === undefined ? (
            ""
          ) : value.text ? (
            value.text
          ) : value === "Threat" ? (
            <span>{value}</span>
          ) : (
            <span className="turquoiseBlue">{value}</span>
          )}
        </td>)
      }else{
      return this.props.dataItem.role === "Standard User" ||
      this.props.dataItem.role === "View Only" ? (
        <td
        //   className={this.state.oppertunityValue}
          // style={{ left: "290px", right: "0px" }}
        >
          {" "}
          {value === null || value === undefined ? (
            ""
          ) : value.text ? (
            value.text
          ) : value === "Threat" ? (
            <span>{value}</span>
          ) : (
            <span className="turquoiseBlue">{value}</span>
          )}
        </td>
      ) : (
        <td
          onClick={this.handleEditCell}
        //   className={this.state.oppertunityValue}
          // style={{ left:'447px', right: "0px" }}
        >
          {" "}
          {value === null || value === undefined ? (
            ""
          ) : value.text ? (
            value.text
          ) : value === "Threat" ? (
            <span>{value}</span>
          ) : (
            <span className="turquoiseBlue">{value}</span>
          )}
        </td>
      );
    }
    }
  }
}
